export * from '@taqueria/protocol/out/types/ScaffoldConfig';
